<template>
  <div class="flex-page">
    <div class="flex-1">
      <section class="goods-list section-common">
        <h4 class="section-title">退款商品</h4>

        <div class="refund-item" v-for="goods in refundGoodsList" :key="goods.orderDetailId">
          <ProductItem :item="goods" :showAction="false" :showImage="orderClassifyType != '1'"></ProductItem>
        </div>
      </section>

      <section class="refund-reason section-common" style="padding-bottom: 8px">
        <h4 class="section-title">退款信息</h4>
        <van-field
          class="reason-input require-after"
          :border="false"
          readonly
          clickable
          label="退款原因"
          :value="refundName"
          right-icon="cap-arrow"
          placeholder="请选择"
          @click="showRefundReason"
        />

        <div style="padding: 0 12px" v-if="refundReasonId == OTHER_REASON_CODE">
          <van-field
            class="other-reason-input"
            :border="false"
            v-model="refundReason"
            direction="column"
            rows="2"
            autosize
            type="textarea"
            maxlength="200"
            placeholder="请输入退款原因"
          />
        </div>

        <div class="price-info">
          <div class="price-cell">
            <span class="title">退款金额</span>
            <span class="red-color">¥{{ amountInfo.maxRefundAmount | price }}</span>
          </div>
          <p class="tip">
            不可修改，最多¥{{ amountInfo.maxRefundAmount | price }}
            <span v-if="amountInfo.maxRefundExpressFee">
              ，含综合服务费¥{{ amountInfo.maxRefundExpressFee | price }}
            </span>
            <span v-if="hasExpressFeeInOrder && !amountInfo.maxRefundExpressFee">
              ，因有其他商品仍需发货，故综合服务费不退
            </span>
            <span v-if="amountInfo.maxRefundDecoctionFee">
              ，含代煎服务费¥{{ amountInfo.maxRefundDecoctionFee | price }}
            </span>
          </p>
        </div>
      </section>

      <section class="section-common" style="padding-bottom: 16px">
        <h4 class="section-title">补充描述和凭证</h4>

        <div class="input-container">
          <van-field
            class="remark-input"
            :border="false"
            v-model="refundRemark"
            direction="column"
            rows="2"
            autosize
            type="textarea"
            maxlength="200"
            placeholder="补充描述，以方便商家更好的处理售后问题"
            show-word-limit
          />
          <upload-image class="refund-img" :limit="3" @handleImageChange="handleImageChange"></upload-image>
        </div>
      </section>
    </div>

    <footer class="btns">
      <van-button :disabled="isRequesting" class="confirm-btn" type="primary" @click="handleRefundConfirm">
        提交申请
      </van-button>
    </footer>

    <van-modal-sheet
      style="height: 500px"
      v-model="showModal"
      title="退款原因"
      right-text="取消"
      size="500"
      right-text-color="#8C8C8C"
      @titleRightClick="titleRightClick"
    >
      <div class="reason-container">
        <div class="reason-list">
          <p class="notice-tip">如遇订单拆分，对应订单全部取消后优惠券可退回</p>

          <section>
            <van-radio-group v-model="reasonRadio">
              <van-cell-group :border="false">
                <van-cell
                  :border="false"
                  v-for="(item, index) in reasonMap"
                  :key="item.refundReasonId"
                  :title="item.desc"
                  clickable
                  @click="reasonRadio = item.refundReasonId"
                >
                  <template #right-icon>
                    <van-radio :name="item.refundReasonId" />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-radio-group>
          </section>
        </div>

        <div class="btns">
          <van-button class="confirm-btn" round type="primary" size="middle" @click="confirmReason">确定</van-button>
        </div>
      </div>
    </van-modal-sheet>
  </div>
</template>

<script>
import ProductItem from './components/productItem';

// import goodsItem from '@/components/goodsItem.vue';
import Price from '@/components/Price.vue';
import PriceInfo from '@/components/PriceInfo.vue';
import BottomTab from '@/components/BottomTab.vue';
import GoodsItem from '@/components/goodsItem.vue';
import UploadImage from './components/UploadImage.vue';

export default {
  name: 'Refunds',
  components: {
    ProductItem,
    Price,
    BottomTab,
    PriceInfo,
    UploadImage,
    GoodsItem
  },
  data() {
    return {
      OTHER_REASON_CODE: 1999,
      orderSn: '',
      refundReasonId: '',
      refundRemark: '',
      refundReason: '',

      imgList: [],

      refundGoodsList: [],

      amountInfo: {},

      applyRefund: {
        reason: '',
        images: [],
        orderId: ''
      },

      isRequesting: false,

      showModal: false,
      reasonRadio: '',
      refundName: '',
      reasonMap: [],
      refundItemParamList: [],
      orderClassifyType: '2'
    };
  },

  computed: {
    imgNum() {
      return this.applyRefund.images.length;
    },
    hasExpressFeeInOrder() {
      const { expressFee = '' } = this.$route.query;
      if (Number(expressFee) === 0) {
        return false;
      }
      return true;
    }
  },

  created() {
    this.fetchData();
    const { orderClassifyType = '2' } = this.$route.query;
    this.orderClassifyType = orderClassifyType;
  },

  methods: {
    async fetchData() {
      try {
        const { orderSn } = this.$route.query;
        this.orderSn = orderSn;
        this.refundGoodsList = JSON.parse(localStorage.getItem('ZYYD_REFUND_GOODS')) || [];

        const refundItemParamList = this.refundGoodsList.map((ele) => ({
          orderDetailId: ele.orderDetailId,
          refundNum: ele.refundNum
        }));

        this.refundItemParamList = refundItemParamList;

        this.$fetch.getSupplyRefundReason({ orderSn }).then((res = []) => {
          this.reasonMap = res;
        });

        this.$fetch
          .getGoodsRefundAmount({
            orderSn,
            refundItemParamList
          })
          .then((res = {}) => {
            this.amountInfo = res;
          });
      } catch (e) {
        this.orderData = {};
      }
    },

    handleRefundConfirm() {
      if (!this.refundReasonId) {
        this.$toast('请填写退款原因');
        return;
      }

      if (this.refundReasonId == this.OTHER_REASON_CODE && !this.refundReason) {
        this.$toast('请填写退款原因');
        return;
      }

      const { orderSn, refundReasonId, refundRemark, refundReason = null, refundItemParamList } = this;
      const params = {
        refundExpressFee: this.amountInfo.maxRefundExpressFee,
        refundAmount: this.amountInfo.maxRefundAmount,
        orderSn,
        refundReasonId,
        refundRemark,
        refundItemParamList,
        refundReason,
        refundImages: this.applyRefund.images
      };

      this.isRequesting = true;
      this.$fetch
        .supplyApplyRefund(params)
        .then(({ refundOrderSn = '' }) => {
          this.isRequesting = false;

          this.$router.replace('/refund/' + refundOrderSn);

          setTimeout(() => {
            this.$toast('退款申请已提交，我们将在审核通过后的7个工作日内为您完成退款');
          }, 300);
        })
        .catch(() => {
          this.isRequesting = false;
        });
    },

    handleImageChange(list) {
      this.applyRefund.images = list || [];
    },

    showRefundReason() {
      this.reasonRadio = this.refundReasonId;
      this.showModal = !this.showModal;
    },
    confirmReason() {
      this.refundReasonId = this.reasonRadio;
      const arr = this.reasonMap.filter((ele) => this.refundReasonId === ele.refundReasonId) || [];
      this.refundName = arr[0].desc;
      this.showModal = !this.showModal;
    },
    titleRightClick() {
      this.showModal = !this.showModal;
    }
  }
};
</script>
<style lang="less" scoped>
.section-title {
  font: 500 16px/16px PingFangSC-Regular, PingFang SC;
  color: #262626;
  padding: 0 12px 12px;
}
.flex-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100%;
  .flex-1 {
    flex: 1;
    overflow: auto;
    padding: 12px;
  }
  .section-common {
    margin-bottom: 12px;
    background: #fff;
    padding-top: 16px;
    overflow: hidden;
    border-radius: 8px;
  }
  .goods-list {
    .refund-item {
      padding: 16px 12px;
    }
    .product-item {
      margin: 0;
      /deep/ .merchandise-info__image {
        border: 1px solid #ebebeb;
      }
      /deep/ .num {
        margin-top: 8.5px;
      }
      &::after {
        border-top: 0;
        border-bottom-width: 1px;
      }
    }
    .product-item:last-child {
      margin: 0;
      &::after {
        border-bottom: 0;
      }
    }
  }
  .refund-reason {
    .reason-input {
      padding: 12px;
      /deep/.van-field__label {
        font-size: 14px;
        color: #262626 !important;
        position: relative;
        &::after {
          position: absolute;
          left: 56px;
          top: 4px;
          color: #ff4e47;
          font-size: 12px;
          content: '\e742';
          font: normal normal normal 14px/1 'vant-icon';
        }
      }
      /deep/.van-field__control {
        text-align: right;
        font-size: 14px;
        margin-right: 9.5px;
      }

      /deep/ .van-field__right-icon {
        min-width: 12px;
        width: 12px;
        margin: 0;
        padding: 0;
        .van-icon-cap-arrow {
          font-size: 12px;
        }
      }
    }
    .other-reason-input {
      background: #f5f5f5;
      border-radius: 2px;
      overflow: hidden;
      // margin: 0 12px;
    }
    .price-info {
      padding: 14px 12px;
      font-size: 14px;
      color: #262626;
      .tip {
        margin-top: 8px;
        font-size: 12px;
        color: #8c8c8c;
      }
    }
    .price-cell {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title {
        position: relative;
        &::after {
          position: absolute;
          left: 56px;
          top: 0px;
          color: #ff4e47;
          font-size: 12px;
          content: '\e742';
          font: normal normal normal 14px/1 'vant-icon';
        }
      }
      .red-color {
        color: #f23400;
      }
    }
  }

  .input-container {
    background: #f9faf9;
    overflow: hidden;
    border-radius: 6px;
    margin: 0 12px;
    .remark-input {
      padding: 0 12px;
      background: #f9faf9;
      margin-bottom: 20px;
    }
    .refund-img {
      padding: 0 12px 16px;
    }
    .reason-input {
      background: #f5f5f5;
    }
  }
}
.btns {
  padding: 8px 16px;
  min-height: 56px;
  height: 56px;
  background: #fff;
  .confirm-btn {
    width: 100%;
  }
}
.reason-container {
  width: 100%;
  height: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .reason-list {
    -webkit-overflow-scrolling: touch;
    max-height: 396px;
    flex: 1 1 396px;
    overflow: scroll;
  }
  .notice-tip {
    background: #fff7e6;
    color: #ff8200;
    font-size: 12px;
    padding: 12px;
    margin: 0 16px;
    border-radius: 6px;
    overflow: hidden;
  }
}
</style>
